import { Select, SelectOption, SimpleBuilder, TextInput } from "o4a-react";
import * as React from "react";
import { Icon, Link, mergeStyleSets, Stack, Text } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";
import { tagsLearnMoreUrl } from "../../constants/docConstants";
import { validateTagKey } from "../../helpers/validationHelper";

export const Fields = {
  name: "name",
  value: "value",
  resources: "resources",
};

const openInNewTabIcon = "OpenInNewWindow";

const classNames = mergeStyleSets({
  container: { padding: "10px", width: "710px" },
  separator: { padding: "2px 8px" },
  icon: { paddingLeft: "5px" },
  nameInput: { width: "33%", minWidth: "107px" },
  valueInput: { width: "33%", minWidth: "107px" },
  resourceSelect: { width: "33%", minWidth: "107px" },
});

interface Props {
  fieldName: string;
  resourceOptions: SelectOption[];
}

export const TagsInput = ({ resourceOptions, fieldName }: Props): JSX.Element => (
  <Stack className={classNames.container}>
    <div>
      <Text>{Messages.tags.description()}</Text>
      <Link href={tagsLearnMoreUrl} target="_blank">
        <>
          <span>
            {Messages.tags.info.learnMore()}
          </span>
          <Icon className={classNames.icon} iconName={openInNewTabIcon} />
        </>
      </Link>
    </div>
    <br />
    <div>
      <Text>{Messages.tags.note()}</Text>
    </div>
    <br />
    <SimpleBuilder fieldName={fieldName}>
      <TextInput
        label={Messages.common.name()}
        tooltip={Messages.hints.tooltipTagName()}
        fieldName={Fields.name}
        className={classNames.nameInput}
        validator={validateTagKey}
      />
      <span className={classNames.separator}>:</span>
      <TextInput
        label={Messages.common.value()}
        tooltip={Messages.hints.tooltipTagValue()}
        fieldName={Fields.value}
        className={classNames.valueInput}
      />
      <span className={classNames.separator}>&nbsp;</span>
      <Select
        label={Messages.labels.resource()}
        multiSelect
        disabled={resourceOptions.length === 1}
        selectAllOption={resourceOptions.length > 1 ? true : undefined}
        showCount={resourceOptions.length > 1 ? true : undefined}
        fieldName={Fields.resources}
        defaultValue={resourceOptions.map(option => option.id)}
        options={resourceOptions}
        className={classNames.resourceSelect}
        hideSearchBox
      />
    </SimpleBuilder>
  </Stack>
);
